module.exports = __webpack_public_path__ + "img/empty-files.450b0950.svg";